module.exports = __webpack_public_path__ + "fonts/SupercellText-Medium.f1e41151.woff2";